<template lang="html">
    <div id="posSwitchConfirm">
        <div class="rel d-flex justify-content-center align-items-start align-content-start">
            <div class="floatRectangle mt-5">
                <div class="rel d-flex flex-wrap justify-content-start align-items-center align-content-center px-4 px-md-5 py-5">
                    <span class="w-100 font-3 titleSelect text-start ts-11">{{phrases.f1[lang]}}</span>
                    <span class="w-100 font-5 subtitleSelect text-start mt-3">{{phrases.f2[lang]}} <b>{{cityName}}</b> {{phrases.f3[lang]}}</span>

                    <div class="w-100 d-flex flex-wrap flex-sm-nowrap justify-content-end mt-4">
                        <button class="confirmButton pushable font-9 px-4 py-3 me-sm-3 mb-3 mb-sm-0" @click="cancel()">{{phrases.f5[lang]}}</button>
                        <button class="confirmButton pushable active font-9 px-4 py-3" @click="accept()">{{phrases.f4[lang]}}</button>
                    </div>

                    <div @click="cancel()" class="closeConfirm font-7 d-flex align-items-center align-content-center justify-content-center" role="button">
                        <img :src="a10" v-svg-inline>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"posSwitchConfirm",
    emits:['accept', 'cancel'],
    props:{
        lang:{
            default:"es",
            type: String
        },
        cityName:{ //nombre de la ciudad/sucursal destino
            default:"",
            type: String
        },
    },
    methods:{
        accept(){
            this.$emit('accept');
        },
        cancel(){
            this.$emit('cancel');
        },
    },
    data(){
        return{
            a10:require('@/assets/images/a10.svg'),
            phrases:{
                f1:{
                    es:"Cambio de sucursal",
                    en:"Branch change"
                },
                f2:{
                    es:"El menú de",
                    en:"The menu of"
                },
                f3:{
                    es:"es diferente y tu carrito actual se vaciará. ¿Deseas continuar?",
                    en:"is different and your current cart will be emptied. Do you want to continue?"
                },
                f4:{
                    es:"Continuar y vaciar",
                    en:"Continue and empty"
                },
                f5:{
                    es:"Cancelar",
                    en:"Cancel"
                }
            }
        }
    }
}
</script>
<style lang="css" scoped>
    #posSwitchConfirm{
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(0px);
        z-index: 4100;
        position: fixed;
        top:0;
        left:0;
        animation:appear 0.2s linear 1 forwards;
    }
    .rel{
        position: relative;
        width: 100%;
        height: 100%;
    }
    .floatRectangle{
        width: 600px;
        max-width: 90%;
        min-height: 200px;
        background-color: #fff;
        position: absolute;
        align-content: center;
        align-items:center;
        animation:append 0.4s linear 1 forwards;
    }
    .titleSelect{
        color:var(--primary);
        user-select: none;
    }
    .subtitleSelect{
        color:var(--text10);
    }
    .closeConfirm{
        position: absolute;
        width: 50px;
        background-color: transparent;
        height: 50px;
        right: 10px;
        padding-bottom: 10px;
        font-size: 40px;
        color:var(--text10);
        top: 10px;
    }
    .closeConfirm svg{
        height: 25px;
        pointer-events: none
    }
    .confirmButton{ /* mismo estilo que accountButton de account.vue */
        font-size: 18px;
        background-color: var(--tertiary);
        color:var(--text3);
        border: 2px solid var(--text12);
        outline: none;
        border-radius: 12px;
        pointer-events: none;
        transition: all 0.2s ease;
    }
    .confirmButton.pushable{
        pointer-events: all;
        cursor: pointer;
    }
    .confirmButton.active{
        background-color: var(--primary);
        border: 2px solid var(--primary);
        color:var(--text2);
    }
    .confirmButton.pushable:hover{
        background-color: var(--primary);
        border: 2px solid var(--primary);
        filter: contrast(0.9);
        color:var(--text2);
    }
    .confirmButton.pushable:active{
        transform: scale(1);
        background-color: var(--quinary);
    }
    @keyframes append {
        0%{
            transform: translateY(-150%);
            opacity: 0.3;
        }
        90%{
            transform: translateY(20%);
        }
        100%{
            transform: translateY(0%);
            opacity: 1;
        }
    }
    @keyframes appear {
        0%{
            backdrop-filter: blur(0px);
        }
        100%{
            backdrop-filter: blur(8px);
        }
    }
</style>
